module.exports = __webpack_public_path__ + "static/media/landscape.9d84d773.png";